module.exports = __webpack_public_path__ + "9e69d7d404aba2ad9c863e7ade81e912.png";